<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="代码"
                ><a-input v-model="queryParam.code" placeholder="代码"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="名称"
                ><a-input v-model="queryParam.descript" placeholder="名称"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="状态">
                  <a-select
                    v-model="queryParam.sta"
                    placeholder="状态"
                    allowClear
                  >
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option value="R">待上线</a-select-option>
                    <a-select-option value="I">已上线</a-select-option>
                    <a-select-option value="X">已下线</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="类型">
                  <a-select
                    v-model="queryParam.type"
                    placeholder="类型"
                    allowClear
                  >
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option value="package">套餐</a-select-option>
                    <a-select-option value="single">零售</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button
                  class="button-margin-left"
                  @click="() => (queryParam = {})"
                  >重置</a-button
                >
                <a-button
                  type="primary"
                  icon="plus"
                  class="button-margin-left"
                  @click="add"
                  v-hasAnyPermission="`contract:add`"
                  >新建</a-button
                >
                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
      >
        <span slot="nickname" slot-scope="text, record">
          <template>
            <img
              :src="record.imageUrl"
              class="user-head"
              v-if="record.imageUrl"
            />
            {{ text }}
          </template>
        </span>
        <span slot="sta" slot-scope="text">
          <a-tag :color="text == 'I' ? '#87d068' : text == 'R' ? '' : '#f50'">
            {{ text == "I" ? "已上线" : text == "R" ? "待上线" : "已下线" }}
          </a-tag>
        </span>
        <span slot="usertype" slot-scope="text">
          <a-tag :color="text == 'package' ? '#2db7f5' : '#87d068'">
            {{ text == "package" ? "套餐" : "零售" }}
          </a-tag>
        </span>
        <span slot="halt" slot-scope="text">
          <a-tag :color="text == 'F' ? '#87d068' : '#f50'">
            {{ text == "F" ? "否" : "是" }}
          </a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              v-hasAnyPermission="`contract:edit`"
              @click="action(record, 'edit')"
              >编辑</a
            >

            <a-popconfirm
              title="确认删除?"
              @confirm="action(record, 'del')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`contract:delete`"
              ><a class="a-action">删除</a></a-popconfirm
            >
          </template>
        </span>
      </s-table>
    </a-card>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";

export default {
  name: "ContractGoodsList",
  components: {
    STable,
    PageView
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: "代码",
          dataIndex: "code",
          scopedSlots: { customRender: "nickname" }
        },
        {
          title: "名称",
          dataIndex: "descript"
        },
        {
          title: "类型",
          dataIndex: "type",
          scopedSlots: { customRender: "usertype" }
        },
        {
          title: "单价(元)",
          dataIndex: "unitPrice"
        },
        {
          title: "售价(元)",
          dataIndex: "salePrice"
        },
        {
          title: "合同份数",
          dataIndex: "value"
        },
        {
          title: "状态",
          dataIndex: "sta",
          scopedSlots: { customRender: "sta" }
        },
        {
          title: "是否停用",
          dataIndex: "isHalt",
          scopedSlots: { customRender: "halt" }
        },
        {
          title: "排序",
          dataIndex: "listOrder"
        },
        {
          title: "操作人",
          dataIndex: "modifyUser"
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime"
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          fixed: "right",
          width: 120,
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.roomBksApi
          .pageContractGoodsBase(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {},
  methods: {
    add() {
      this.$router.push({
        name: "ContractGoodsInfo",
        query: {
          opt: "add"
        }
      });
    },
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "edit") {
        this.$router.push({
          name: "ContractGoodsInfo",
          query: {
            opt: "modify",
            info: record
          }
        });
      } else if (type == "del") {
        this.$http.roomBksApi
          .removeContractGoodsBase({ id: record.id })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$message.success(res.msg);
            }
          });
      }
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    }
  }
};
</script>
<style lang="less">
.user-head {
  width: 40px;
  height: 40px;
  margin-right: 5px;
}
</style>
